import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';

export default () => {
  return (
    <Container>
      <SaveTheDate>Save the Date!</SaveTheDate>
      <TextContainer>
        Liebe Kundinnen und Kunden,
        <br /> 2026 wird die Hirsch-Apotheke 285 Jahre alt!
        <br />
        Dieses Jubiläum möchten wir mit Ihnen feiern!
      </TextContainer>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-height: 500px;
  position: relative;
  overflow: hidden;
  padding: 5rem 2rem;
`;

const SaveTheDate = styled.div`
  font-size: 1.2em;
  font-weight: bold;
  color: ${colors.red};
  line-height: 2em;
  letter-spacing: 2px;
`;
const TextContainer = styled.div`
  width: 100%;
  font-size: 1.2em;
  line-height: 2em;
`;
